<template>
	<div :class="'widget ' + tamplate">
		<template v-if="tamplate === 'transfer-user'">
			<template v-if="delay">
				<b-skeleton class="mb-2" style="margin: auto;" width="50px" height="50px" type="avatar"/>
				<b-skeleton style="margin: auto;" width="50%"/>
			</template>
			<template v-else>
				<template v-if="boolean">
					<div>
						<i class="fal fa-file-alt" style="font-size: 48px;"/>
					</div>
				</template>
				<template v-else>
					<div>
                        <b-avatar variant="default" :src="transferUser.image ? transferUser.image : ''" :text="transferUser.name ? $options.filters['namegr'](transferUser.name) : ''" size="3rem"/>
					</div>
				</template>
				<small class="text-muted">
					<router-link class="text-space" :to="'/address/'+ address"><b>{{ transferUser.name ? transferUser.name : address }}</b></router-link>
				</small>
			</template>
		</template>
	</div>
</template>

<script lang="js">

	import axios    from "axios";
	import api      from "../libs/api";

	export default {
		name: "widget",
		props: {
			scopeTemplate: {
				type: String
			},
			scopeAddress: {
				type: String
			},
			scopeBoolean: {
				type: Boolean
			}
		},
		data() {
			return {
				address: this.$props.scopeAddress,
				tamplate: this.$props.scopeTemplate,
				boolean: this.$props.scopeBoolean,
				delay: false,
				transferUser: {
					image: null,
					name: null
				}
			}
		},
		created() {
			switch (this.$data.tamplate) {
				case 'transfer-user':
					this.getTransferUser(this.$data.address);
				break;
			}
		},
		methods: {
			getTransferUser(address) {
				if (!this._.isNull(address)) {
					this.$data.delay = true;
					this.$data.transferUser.image = null;
					this.$data.transferUser.name = null;
					axios.post(api.account.info, {address: address}).then(async (response) => {
						await this.$storage("account", response.data.address, response.data.image).then((image) => {
							this.$data.transferUser.image = image;
							this.$data.transferUser.name = response.data.name;
							this.$data.delay = false;
						});
					}).catch(() => {
						this.$data.delay = false;
					});
				}
			}
		}
	}
</script>

<style scoped>

	.widget {
		width: 100%;
	}

	.widget.transfer-user {

	}

</style>